var _rect, _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorLearnit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 734,
    height: 511,
    viewBox: "0 0 734 511",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2502_2966",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 734,
    height: 511
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.234375,
    width: 734.002,
    height: 510.069,
    fill: "url(#paint0_linear_2502_2966)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2502_2966)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_2502_2966",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88 53C88 39.7451 98.7452 29 112 29H622.307C635.562 29 646.307 39.7452 646.307 53V395.791C646.307 413.464 631.98 427.791 614.307 427.791H120C102.327 427.791 88 413.464 88 395.791V53Z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2502_2966)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88 53C88 39.7451 98.7452 29 112 29H622.307C635.562 29 646.307 39.7452 646.307 53V395.791C646.307 413.464 631.98 427.791 614.307 427.791H120C102.327 427.791 88 413.464 88 395.791V53Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M112 31H622.307V27H112V31ZM644.307 53V395.791H648.307V53H644.307ZM614.307 425.791H120V429.791H614.307V425.791ZM90 395.791V53H86V395.791H90ZM120 425.791C103.431 425.791 90 412.359 90 395.791H86C86 414.568 101.222 429.791 120 429.791V425.791ZM644.307 395.791C644.307 412.359 630.875 425.791 614.307 425.791V429.791C633.084 429.791 648.307 414.568 648.307 395.791H644.307ZM622.307 31C634.457 31 644.307 40.8497 644.307 53H648.307C648.307 38.6406 636.666 27 622.307 27V31ZM112 27C97.6406 27 86 38.6406 86 53H90C90 40.8497 99.8497 31 112 31V27Z",
    fill: "url(#paint1_linear_2502_2966)",
    mask: "url(#path-2-inside-1_2502_2966)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2502_2966)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96 29C91.5817 29 88 32.5817 88 37V392.335C88 396.753 91.5817 400.335 96 400.335H638C642.418 400.335 646 396.753 646 392.335V37C646 32.5817 642.418 29 638 29H96Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2502_2966)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88 29V93H646V29H88Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2502_2966)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112 69C116.418 69 120 65.4183 120 61C120 56.5817 116.418 53 112 53C107.582 53 104 56.5817 104 61C104 65.4183 107.582 69 112 69Z",
    fill: "#FF3F31"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136 69C140.418 69 144 65.4183 144 61C144 56.5817 140.418 53 136 53C131.582 53 128 56.5817 128 61C128 65.4183 131.582 69 136 69Z",
    fill: "#FFDF17"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160 69C164.418 69 168 65.4183 168 61C168 56.5817 164.418 53 160 53C155.582 53 152 56.5817 152 61C152 65.4183 155.582 69 160 69Z",
    fill: "#2BAE7A"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188 45C185.791 45 184 46.7909 184 49V73C184 75.2091 185.791 77 188 77H618C620.209 77 622 75.2091 622 73V49C622 46.7909 620.209 45 618 45H188Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bi_2502_2966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 142.992C48 129.737 58.7452 118.992 72 118.992H662.065C675.32 118.992 686.065 129.737 686.065 142.992V461.843C686.065 481.725 669.947 497.843 650.065 497.843H84C64.1178 497.843 48 481.725 48 461.843V142.992Z",
    fill: "#E0E0E0",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4688 142.992C49.4688 130.549 59.5563 120.461 72 120.461H662.065C674.508 120.461 684.596 130.549 684.596 142.992V461.843C684.596 480.914 669.136 496.374 650.065 496.374H84C64.9289 496.374 49.4688 480.914 49.4688 461.843V142.992Z",
    stroke: "url(#paint2_linear_2502_2966)",
    strokeWidth: 2.9375
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_bdi_2502_2966)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_b_2502_2966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M431.324 251.715L383.35 167.614C378.335 158.63 366.919 155.327 357.944 160.354C354.843 162.005 352.335 164.575 350.685 167.554L302.382 252.309C298.488 261.815 303.107 272.781 312.676 276.679C314.589 277.405 316.635 277.874 318.681 278H415.288C420.238 277.736 424.791 275.556 428.156 271.863C431.522 268.157 433.237 263.341 432.973 258.387C432.842 256.266 432.38 254.225 431.324 251.715Z",
    fill: "url(#paint3_linear_2502_2966)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.785 251.521C431.777 251.502 431.768 251.484 431.758 251.467L383.786 167.37C383.786 167.369 383.786 167.369 383.785 167.368C378.637 158.149 366.922 154.755 357.704 159.915C354.516 161.614 351.942 164.254 350.249 167.309C350.249 167.31 350.248 167.311 350.248 167.312L301.947 252.062C301.936 252.08 301.927 252.1 301.919 252.12C297.92 261.883 302.664 273.141 312.487 277.142L312.487 277.142L312.498 277.146C314.455 277.889 316.55 278.37 318.65 278.499C318.66 278.5 318.671 278.5 318.681 278.5H415.288C415.297 278.5 415.306 278.5 415.315 278.499C420.398 278.228 425.073 275.988 428.526 272.2L428.526 272.199C431.981 268.395 433.744 263.449 433.473 258.36L433.473 258.356C433.337 256.174 432.86 254.078 431.785 251.521Z",
    stroke: "url(#paint4_linear_2502_2966)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "path-15-inside-2_2502_2966",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.987 228.857C370.154 228.857 372.728 226.208 372.728 223.037V204.349C372.728 201.171 370.154 198.602 366.987 198.602C363.819 198.602 361.18 201.171 361.18 204.349V223.037C361.18 226.208 363.819 228.857 366.987 228.857ZM361.18 245.632C361.18 248.797 363.819 251.446 366.987 251.446C370.154 251.446 372.728 248.797 372.728 245.56C372.728 242.395 370.154 239.812 366.987 239.812C363.819 239.812 361.18 242.455 361.18 245.632Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.987 228.857C370.154 228.857 372.728 226.208 372.728 223.037V204.349C372.728 201.171 370.154 198.602 366.987 198.602C363.819 198.602 361.18 201.171 361.18 204.349V223.037C361.18 226.208 363.819 228.857 366.987 228.857ZM361.18 245.632C361.18 248.797 363.819 251.446 366.987 251.446C370.154 251.446 372.728 248.797 372.728 245.56C372.728 242.395 370.154 239.812 366.987 239.812C363.819 239.812 361.18 242.455 361.18 245.632Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.328 223.037C372.328 225.994 369.926 228.457 366.987 228.457V229.257C370.382 229.257 373.128 226.422 373.128 223.037H372.328ZM372.328 204.349V223.037H373.128V204.349H372.328ZM366.987 199.002C369.933 199.002 372.328 201.392 372.328 204.349H373.128C373.128 200.95 370.375 198.202 366.987 198.202V199.002ZM361.58 204.349C361.58 201.398 364.034 199.002 366.987 199.002V198.202C363.604 198.202 360.78 200.945 360.78 204.349H361.58ZM361.58 223.037V204.349H360.78V223.037H361.58ZM366.987 228.457C364.041 228.457 361.58 225.988 361.58 223.037H360.78C360.78 226.428 363.597 229.257 366.987 229.257V228.457ZM366.987 251.046C364.041 251.046 361.58 248.576 361.58 245.632H360.78C360.78 249.017 363.598 251.846 366.987 251.846V251.046ZM372.328 245.56C372.328 248.586 369.923 251.046 366.987 251.046V251.846C370.385 251.846 373.128 249.008 373.128 245.56H372.328ZM366.987 240.213C369.933 240.213 372.328 242.616 372.328 245.56H373.128C373.128 242.175 370.376 239.412 366.987 239.412V240.213ZM361.58 245.632C361.58 242.675 364.041 240.213 366.987 240.213V239.412C363.598 239.412 360.78 242.235 360.78 245.632H361.58Z",
    fill: "url(#paint5_linear_2502_2966)",
    mask: "url(#path-15-inside-2_2502_2966)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2502_2966",
    x: 88,
    y: 29,
    width: 558.309,
    height: 398.791,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 29.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2502_2966"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2502_2966",
    x: 8,
    y: -11,
    width: 718,
    height: 531.334,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 40
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.753637 0 0 0 0 0.775589 0 0 0 0 0.797541 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2502_2966"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2502_2966",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bi_2502_2966",
    x: 24,
    y: 94.9922,
    width: 686.066,
    height: 426.852,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2502_2966"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2502_2966",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2502_2966"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_bdi_2502_2966",
    x: 276,
    y: 139,
    width: 182,
    height: 170,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5.44548
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2502_2966"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.670833 0 0 0 0 0.670833 0 0 0 0 0.670833 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_2502_2966",
    result: "effect2_dropShadow_2502_2966"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2502_2966",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.36137
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.680685
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.94902 0 0 0 0 0.945098 0 0 0 0 0.929412 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_2502_2966"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_b_2502_2966",
    x: 276,
    y: 133,
    width: 182,
    height: 170,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2502_2966"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2502_2966",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2502_2966",
    x1: 367.001,
    y1: 0.234375,
    x2: 367.001,
    y2: 302.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.405973
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2502_2966",
    x1: 88,
    y1: 29,
    x2: 88,
    y2: 427.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2502_2966",
    x1: 48,
    y1: 118.992,
    x2: 48,
    y2: 497.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.13
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2502_2966",
    x1: 367,
    y1: 149.5,
    x2: 367,
    y2: 278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDA17"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2502_2966",
    x1: 301,
    y1: 158,
    x2: 301,
    y2: 278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.13
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2502_2966",
    x1: 361.18,
    y1: 198.602,
    x2: 361.18,
    y2: 251.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2502_2966"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88 37C88 32.5817 91.5817 29 96 29H638C642.418 29 646 32.5817 646 37V93H88V37Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2502_2966"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 16,
    fill: "white",
    transform: "translate(104 53)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorLearnit);
export default __webpack_public_path__ + "static/media/error_learnit.d4181c8baacc2de496bf97f55498a31b.svg";
export { ForwardRef as ReactComponent };